export { default as controlIconRegistration } from './data/controlIconsRegistration';
export { default as ControlIcons } from './data/ControlIcons';
